import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';

export class BrDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      const text = value.trim();
      if (!text) {
        return null;
      }

      const brPattern = /^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{4})$/;
      const brMatch = brPattern.exec(text);
      if (brMatch) {
        return this.parseSafeDate(Number(brMatch[3]), Number(brMatch[2]), Number(brMatch[1]));
      }

      const isoPattern = /^(\d{4})-(\d{2})-(\d{2})$/;
      const isoMatch = isoPattern.exec(text);
      if (isoMatch) {
        return this.parseSafeDate(Number(isoMatch[1]), Number(isoMatch[2]), Number(isoMatch[3]));
      }
    }

    const parsed = super.parse(value);
    if (!parsed || Number.isNaN(parsed.getTime())) {
      return null;
    }
    return parsed;
  }

  override format(date: Date, displayFormat: any): string {
    if (displayFormat === 'input') {
      const day = `${date.getDate()}`.padStart(2, '0');
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return super.format(date, displayFormat);
  }

  private parseSafeDate(year: number, month: number, day: number): Date | null {
    const parsed = new Date(year, month - 1, day);
    if (
      Number.isNaN(parsed.getTime())
      || parsed.getFullYear() !== year
      || parsed.getMonth() !== month - 1
      || parsed.getDate() !== day
    ) {
      return null;
    }
    return parsed;
  }
}

export const BR_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'input'
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { month: 'short', year: 'numeric' },
    dateA11yLabel: { day: 'numeric', month: 'long', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' }
  }
};
